// removed by extract-text-webpack-plugin
module.exports = {"enter":"Expand__enter___3h8Ko","enterActive":"Expand__enterActive___1YBP7"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Transitions/Expand.scss
// module id = 564
// module chunks = 0